import React from 'react';
import urls from '../configs/urls'
import { Redirect} from 'react-router'
import '../css/App.css';
import '../css/ReportOrderShow.css';
import ls from 'local-storage';
import Loading from "./Loading";
import Retry from "./Retry";
import axios from "axios";


class ReportOrderShow extends React.Component{
    list =[];
    constructor(props){
        super(props);
        this.state = {
            redirect: false,
            open: false,
            dialogHasConfirm: false,
            retry: false,
            error: false,
            error_text: "",
            dialogText: "",
            dialogTitle: "",
            dialogType: "NONE",
            loading: false,
            order_id:this.props.location.state.id,
            order:[],
            address:[],
            product_list:[],
            pricediscounts:[],
        };
    }



    componentDidMount = () => {
        if(this.props.location.state.id == null)
            this.props.history.push("/home");

        this.loadOrder();
    };

    render() {
        if(this.state.redirect)
            return (<Redirect push to={this.state.url}/>);
        if(this.state.retry)
            return (<Retry url={"/home"} type={"RELOAD"} text={"در اجرای درخواست مشکلی پیش آمده است. لطفا مجددا تلاش کنید."}/>);
        return (
            <div className="App ">
                <Loading loading={this.state.loading}/>
                {this.renderContent()}
            </div>
        );
    }

    renderContent(){
        if(this.state.error)
            return (
                <div className="App-body bg-white">
                    <div className={"infoMessage"}>
                        {this.state.error_text}
                    </div>
                    <form onSubmit={this.handleSubmit}>
                        <input type={"submit"} className={"btn submitPhone"} value={"صفحه اصلی"}/>
                    </form>
                </div>
            );

        let status = "";
        switch (this.state.order.order_status) {
            case("-1"): status = "عدم پرداخت";break;
            case("0"): status = "درانتظار پرداخت";break;
            case("1"): status = "در انتظار تایید مدیریت";break;
            case("2"): status = "در حال آماده سازی";break;
            case("3"): status = "آماده ارسال";break;
            case("4"): status = "تحویل پیک داده شده";break;
            case("5"): status = "تحویل مشتری داده شد";break;
            case("6"): status = "لغو سفارش";break;
            case("10"): status = "در انتظار تایید";break;
            default: status = "نامشخص";break;
        }
        let pay_status = "";
        switch (this.state.order.pay_status) {
            case("0"): pay_status = "درانتظار پرداخت";break;
            case("1"): pay_status = "پرداخت شده";break;
            case("2"): pay_status = "پرداخت درب منزل";break;
            default: pay_status = "نامشخص";break;
        }
        return (
            <div className="App-body bg-white">
                <div className={"content contentCart"} style={{top:"0",backgroundColor:"#F8F8F8",bottom:"0",maxHeight:"none"}}>
                    <div id={"topTitle"} style={{height:"45px",lineHeight:"45px"}}  >
                        <span id={"title"}><i>سفارش {this.state.order_id}</i></span>
                        <img src={`${process.env.PUBLIC_URL}/assets/images/back.png`} onClick={()=>{this.props.history.push("/reports");}} id={"backBtn"} style={{height:"60%",top:"18%"}}/>
                    </div>
                    <div id={"orderViewBody"}>
                        <div className={"orderInfoTitle"}>مشخصات سفارش</div>
                        <div className={"orderInfoRow"}>
                            <div className={"right"}>
                                تاریخ سفارش
                            </div>
                            <div className={"left"}>
                                {this.state.order.date}
                            </div>
                        </div>
                        <div className={"orderInfoRow"}>
                            <div className={"right"}>
                                وضعیت سفارش
                            </div>
                            <div className={"left"}>
                                {status}
                            </div>
                        </div>
                        <div className={"orderInfoRow"}>
                            <div className={"right"}>
                                نحوه پرداخت
                            </div>
                            <div className={"left"}>
                                {pay_status}
                            </div>
                        </div>
                        <div className={"orderInfoRow"}>
                            <div className={"right"}>
                                قیمت کل
                            </div>
                            <div className={"left"}>
                                {new Intl.NumberFormat("fa").format(this.state.pricediscounts)} تومان
                            </div>
                        </div>


                        <div className={"orderInfoTitle"}>مشخصات محصولات</div>
                        {this.state.product_list.map((product)=>{
                            return (
                                <div className={"orderInfoProductItem"}>
                                    <div className={"orderInfoImage"}><img src={product.product_image} style={{width:"100%",height:"100%"}}/> </div>
                                    <div className={"orderInfoProductInfo"}>
                                        <div className={"row"}>{product.product_name}</div>
                                        <div className={"row"}>نام فروشگاه : {product.store_name}</div>
                                        <div className={"row"}>قیمت : {product.product_price}</div>
                                        <div className={"row"}>مقدار : {product.product_number}</div>
                                    </div>
                                </div>
                            );
                        })}


                        <div className={"orderInfoTitle"}>مشخصات آدرس</div>
                        <div className={"orderInfoRow"}>
                            <div className={"right"}>
                                شهر
                            </div>
                            <div className={"left"}>
                                {this.state.address.city_name}
                            </div>
                        </div>
                        <div className={"orderInfoRow"}>
                            <div className={"right"}>
                                محله
                            </div>
                            <div className={"left"}>
                                {this.state.address.mahalat_name}
                            </div>
                        </div>
                        <div className={"orderInfoRow"}>
                            <div className={"right"}>
                                آدرس
                            </div>
                            <div className={"left"}>
                                {this.state.address.address}
                            </div>
                        </div>
                        <div className={"orderInfoRow"}>
                            <div className={"right"}>
                                هزینه پیک
                            </div>
                            <div className={"left"}>
                                {(this.state.order.peyk_price != 0)?(new Intl.NumberFormat("fa").format(this.state.order.peyk_price) + " تومان"):"رایگان"}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    handleClose  = () => {
        this.setState({open:false})
    };
    loadOrder = ()=>{
        this.setState({loading:true});
        axios.get(urls.baseUrl+urls.ShowOrder+"?token="+ls.get("token")+"&id="+this.state.order_id)
            .then(res => {
                console.log("Report Order : ",res.data);
                if(res.data.code == 200){
                    this.setState({
                        order:res.data.order,
                        address:res.data.address,
                        product_list:res.data.product_list,
                        pricediscounts:res.data.pricediscounts,
                        loading:false});
                }
                else{
                    alert(res.data.message())
                }
            })
            .catch(error => {
                console.log(error)
                this.setState({retry:true,loading:false});
            });
    };
    loadPayments = ()=>{

    };
    loadNews = ()=>{

    };
    loadServices = ()=>{

    };

    loadOrderDetails =()=>{

    }
}



export default ReportOrderShow;
